import Cookies from 'js-cookie';

const cookieUtil = {

  // cookie = { name: '', contents:'', expires : 7}
  set_cookie: (cookie) => {
    Cookies.set(cookie.name, cookie.contents, { expires: cookie.expires }); // 7일 후 만료
  },

  get_cookie: (cookie_name) => {
    const cookieValue = Cookies.get(cookie_name);
    if (cookieValue) {
      return { isval: true, val: cookieValue }
    } else {
      return { isval: false, val: '' }
    }
  },

  del_cookie: (cookie_name) => {
    Cookies.remove(cookie_name);
  }
}

export default cookieUtil;